module.exports = __webpack_public_path__ + "img/applepay.fee262f4.svg";